import React, { useEffect } from 'react';
import NavBar from '../_components/navbar';
import { connect, useDispatch, useSelector } from "react-redux";
import { authActions, visitaAction, usuarioAction, fazendaAction } from '../_actions';
import { withRouter } from '../_helpers/withRouter';
import Swal from 'sweetalert2';
import {
    Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader, Button, ButtonGroup, Container, Row, Col, FormGroup, Label, Input, Form,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUndo, faCheck, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select';

const customStyles = {
    option: (provided) => ({
        ...provided,
        textAlign: 'left'
    }),
}

const VisitaEdit = (props) => {

    const dispatch = useDispatch();
    const fazenda = useSelector((state) => state.fazenda.fazenda)

    useEffect(() => {
        const { match: { params } } = props;
        const { dispatch } = props;

        //dispatch(visitaAction.getVisita());
        dispatch(fazendaAction.getFazendaSelect(true));

        if (params.id) {
            dispatch(visitaAction.getVisitaById(params.id, true));
        } else {
            dispatch(visitaAction.clear());
        }

        //if (params.id) {
        //    if (!authActions.isUsuario() || localStorage.getItem("id_user") === params.id) {
        //        //dispatch(usuarioAction.getUsuarioById(params.id, true));
        //    } else {
        //        props.history.push('/usuarios/');
        //    }
        //} else {
        //    if (!authActions.isUsuario() === false) {
        //        props.history.push('/usuarios/');
        //    } else {
        //        dispatch(usuarioAction.clear());
        //    }
        //}

    }, []);

    const handleChange = prop => event => {
        const { dispatch } = props;
        dispatch(visitaAction.onChangeProps(prop, event));
    };

    const handleSelectChange = prop => event => {

        var event2 = {
            type: 'select',
            target: {
                value: event.value
            }
        };
        dispatch(visitaAction.onChangeProps(prop, event2));

    };

    const handleSubmit = event => {

        event.preventDefault();
        const { match: { params } } = props;

        if (handleValidation()) {

            let payload = {
                id: params.id,
                id_fazenda: props.visita.id_fazenda,
                data: props.visita.data,
                tipo_relatorio: props.visita.tipo_relatorio,
                obs: props.visita.obs
            };

            const producaoDia = props.visita.producao_dia ? props.visita.producao_dia : '';
            const animaisLactacao = props.visita.animais_lactacao ? props.visita.animais_lactacao : '';

            if (params.id) {
                dispatch(visitaAction.editVisitaInfo(params.id, payload, true));
            } else {
                if (props.visita.tipo_relatorio === "VT" || props.visita.tipo_relatorio === "VV") {
                    dispatch(visitaAction.createVisitaFrizzo(payload, animaisLactacao, producaoDia, true));
                } else {
                    dispatch(visitaAction.createVisita(payload, true));
                }

            }
        }
    };

    const handleValidation = () => {

        var valid = true;
        var errors = '';

        if (props.visita.data === null || props.visita.data === '') {
            valid = false;
            errors += '<li style="float:left;">Selecione uma data!</li><br>';
        }
        if (props.visita.id_fazenda === null || props.visita.id_fazenda === '0') {
            valid = false;
            errors += '<li style="float:left;">Selecione uma fazenda!</li><br>';
        }
        if (props.visita.tipo_relatorio === null || props.visita.tipo_relatorio === '') {
            valid = false;
            errors += '<li style="float:left;">Selecione um tipo de relatório!</li><br>';
        }
        if (props.visita.obs === null || props.visita.obs === '') {
            valid = false;
            errors += '<li style="float:left;">Digite uma observação!</li><br>';
        }
        if (!valid) {

            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });
        }
        return valid;
    };

    const renderOptionsFazenda = () => {
        return props.fazenda.fazenda.map((p, i) => {
            return (
                { value: p.id, label: p.nome }
            );
        });
    };

    const renderOptionsTipoRelatorio = () => {

        var tipoData = [];

        tipoData = [
            { value: '', name: 'SELECIONE ...' }
        ];

        tipoData.push({ value: 'A', name: 'Relatório de Animais' });
        tipoData.push({ value: 'AN', name: 'Relatório de Animais - Novilhas' });
        tipoData.push({ value: 'AL', name: 'Relatório de Animais - Lactantes e Secas' });
        tipoData.push({ value: 'BS', name: 'Relatório de BST' });
        tipoData.push({ value: 'G', name: 'Relatório de Genealogia' });
        tipoData.push({ value: 'PL', name: 'Relatório de Produção em Lotes' });
        tipoData.push({ value: 'RV', name: 'Relatório de Reprodução - Vacas' });
        tipoData.push({ value: 'RN', name: 'Relatório de Reprodução - Novilhas' });
        tipoData.push({ value: 'V', name: 'Relatório de Visita' });
        if (fazenda.length > 0) {
            const index = fazenda.findIndex((item) => item.id == props.visita.id_fazenda);
            if (index > 0) {
                if (fazenda[index].empresa == 44 || fazenda[index].empresa == 45) {
                    tipoData.push({ value: 'VT', name: 'Relatório de Visita do Técnico' });
                    tipoData.push({ value: 'VV', name: 'Relatório de Visita do Veterinário' });
                }
            }
        }

        return tipoData.map((p, i) => {
            return (
                { value: p.value, label: p.name }
            );
        });
    };

    const { match: { params } } = props;
    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <Breadcrumb>
                                    <BreadcrumbItem><a href="/visitas">Lista de Visitas</a></BreadcrumbItem>
                                    <BreadcrumbItem active>Visita {props.fazenda.id}</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={(event) => handleSubmit(event)}>
                            <Row>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label className="left" for="data">Data *</Label>
                                        <Input
                                            id="data"
                                            label="Data *"
                                            className="form-control"
                                            type="date"
                                            value={props.visita.data}
                                            onChange={handleChange('data')}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label className="left" for="id_fazenda">Fazenda *</Label>
                                        <Select
                                            classNamePrefix="select"
                                            value={renderOptionsFazenda().filter(function (option) {
                                                return option.value == (props.visita.id_fazenda || '');
                                            })}
                                            onChange={handleSelectChange('id_fazenda')}
                                            isSearchable
                                            id="id_fazenda"
                                            name="id_fazenda"
                                            placeholder="Selecione..."
                                            styles={customStyles}
                                            options={renderOptionsFazenda()}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label className="left" for="tipo_relatorio">Tipo *</Label>
                                        <Select
                                            classNamePrefix="select"
                                            value={renderOptionsTipoRelatorio().filter(function (option) {
                                                return option.value === (props.visita?.tipo_relatorio?.trim() || '');
                                            })}
                                            onChange={handleSelectChange('tipo_relatorio')}
                                            isSearchable
                                            id="tipo_relatorio"
                                            name="tipo_relatorio"
                                            placeholder="Selecione..."
                                            styles={customStyles}
                                            options={renderOptionsTipoRelatorio()}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            {props.visita.tipo_relatorio === "VT" &&
                                <Row>
                                    <Col md={3}>
                                        <FormGroup>
                                            <Label className="left" for="animais_lactacao">Quant. Animais em Lactação *</Label>
                                            <Input
                                                id="animais_lactacao"
                                                label="Quant. Animais em Lactação"
                                                type="number"
                                                className="form-control"
                                                value={props.visita.animais_lactacao}
                                                onChange={handleChange('animais_lactacao')} />
                                        </FormGroup>
                                    </Col>
                                    <Col md={3}>
                                        <FormGroup>
                                            <Label className="left" for="producao_dia">Produção de Leite no dia *</Label>
                                            <Input
                                                id="producao_dia"
                                                label="Produção de Leite no dia"
                                                type="number-decimal"
                                                className="form-control"
                                                value={props.visita.producao_dia}
                                                onChange={handleChange('producao_dia')} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            }
                            <Row>
                                <Col md={12}>
                                    <FormGroup>
                                        <Label className="left" for="obs">Observações *</Label>
                                        <Input
                                            id="obs"
                                            label="Observações"
                                            obs="form-control"
                                            value={props.visita.obs || ''}
                                            onChange={handleChange('obs')}
                                            type="textarea"
                                            rows="8"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col className="left" md="8" lg="6">
                                    <span>* Campos obrigatórios</span>
                                </Col>
                                <Col className="d-flex flex-row-reverse" md="4" lg="6">
                                    <ButtonGroup>
                                        <Button variant="contained" color="secondary" component='a' href="/visitas">Voltar <FontAwesomeIcon icon={faUndo} /></Button>
                                        {props.visita.id ? <Button variant="contained" color="danger" component='a' href={props.visita.arquivo} target="_blank">Ver PDF <FontAwesomeIcon icon={faFilePdf} /></Button> : null}
                                        {props.visita.id ? null : <Button variant="contained" color="primary" type="submit">Salvar <FontAwesomeIcon icon={faCheck} /></Button>}

                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
            </Container>
            
        </div>

    );
}



const mapStateToProps = (state) => {
    return state;
};

const connectedVisitaEditPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(VisitaEdit));
export { connectedVisitaEditPage as VisitaEdit };